/*
 * @Author: 小周
 * @Date: 2024-06-12 15:21:26
 * @LastEditTime: 2024-06-12 15:43:02
 * @LastEditors: MrZHLF
 * @Description: 唤醒App
 */

import { useState, useEffect } from 'react'
import { getDevice } from '@utils/index'
import styles from './index.module.scss'

/**
 *
 * @param {Boolean} appPath 是否唤醒App底部菜单位置
 * @param {Boolean} isArticle 是否唤醒App文章
 * @param {String} articleId 文章ID
 * @param {string} redirectPath App底部导航位置 与App协商
 * @param {Number} msgType 文章类型
 * @returns
 */
const OpenLaunchApp = (props = {}) => {
  const [openInfo, setOpenInfo] = useState({})
  const [wxOpenBtn, setWxOpenBtn] = useState('none')
  const [isShow, setIsShow] = useState(false)

  useEffect(() => {
    if (props && props.appPath) {
      // 唤醒菜单栏
      setOpenInfo({
        redirectPath: props.redirectPath,
        msgType: props.msgType,
        isJumpApp: true,
      })
    } else if (props && props.isArticle) {
      // 唤醒文章
      setOpenInfo({
        id: props.articleId,
        msgType: props.msgType,
        isJumpApp: true,
      })
    } else {
      // 外链
      setOpenInfo({
        id: window.location.href,
        msgType: props.msgType,
        isJumpApp: true,
      })
    }
    let device = getDevice()
    if (device.includes('android') && device.includes('wechat')) {
      setWxOpenBtn('block')
      setIsShow(true)
    } else {
      setWxOpenBtn('none')
      setIsShow(false)
    }
  }, [props])

  return (
    <>
      {isShow ? (
        <wx-open-launch-app
          id="launch-btn"
          style={{
            display: `${wxOpenBtn}`,
          }}
          class={styles.openTag}
          appid="wx5dc84714dd7219dd"
          extinfo={JSON.stringify(openInfo)}
        >
          <script type="text/wxtag-template">
            <div
              style={{
                position: 'absolute',
                width: '100%',
                top: 0,
                bottom: 0,
                left: 0,
                right: 0,
              }}
            ></div>
          </script>
        </wx-open-launch-app>
      ) : null}
    </>
  )
}

export default OpenLaunchApp
